import { useEffect } from 'react'
import { shape, string } from 'prop-types'

import { getUserOrganization } from '@/store/selectors'
import { useTypedSelector } from '@/store/hooks'
import { BANNED_APPS } from '@/constants'
import { customNavigate } from '@/utils'

const checkIfBannedApplication = (id, organizationId) => {
  const bannedApp = BANNED_APPS.find(({ appId }) => appId === id)

  return bannedApp && organizationId !== bannedApp.ownerOrganizationId
}

/* 
  HOC for shadow bans logic
  If the user is not the owner of the banned app, redirect to the home page
*/
const withRedirectForBannedApps = (Component) => {
  const WrappedComponent = (props) => {
    const {
      data: {
        app: { id },
      },
    } = props

    const userOrganizationId = useTypedSelector(getUserOrganization)

    useEffect(() => {
      if (checkIfBannedApplication(id, userOrganizationId)) {
        customNavigate('/', { replace: true })
      }
    }, [id, userOrganizationId])

    return <Component {...props} />
  }

  WrappedComponent.propTypes = {
    data: shape({ app: shape({ id: string }) }),
  }

  return WrappedComponent
}

export default withRedirectForBannedApps
